import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class ApiUrlHelper {
  public apiUrl = {
    Account: {
      UserLogin: 'account/login',
      ResendOTP: 'account/resend-otp',
      ChangePassword: 'account/change-password',
      ForgetPassword: "account/forgot-password/send-otp",
      VerificationOTP: 'account/verify-otp',
      ResetPassword: 'account/forgot-password/reset-password',
      ValidateForgotPasswordLink: 'account/validate-forgot-password-link',
      ValidateForgotPassword: 'account/validate-password-link',
      Logout: 'account/logout',
      VerificationForChangePassword: 'account/verify-change-password',
    },
    Role: {
      GetRoleList: 'role/list',
      GetRoleById: 'role/detail/{roleId}',
      SaveRole: 'role/save',
      ActiveInactiveRole: 'role/active-inactive/{roleId}',
      DeleteRole: 'role/delete/{roleId}',
      GetRoleDropdown: 'role/dropdown',
    },
    Dashboard: {
      DashboardDetails: 'dashboard/info'
    },
    User: {
      GetUserList: 'admin-user/list',
      GetUserArchiveList:'admin-user/archive/list',
      GetUserById: 'admin-user/detail/{adminUserId}',
      SaveUser: 'admin-user/save',
      GetUserByProfile: 'admin-user/profile',
      ActiveInactiveUser: 'admin-user/active-inactive/{adminUserId}',
      DeleteUser: 'admin-user/archive/{adminUserId}',
      ArchiveDeleteUser: 'admin-user/delete/{adminUserId}',
    },
    AppUser: {
      GetUserList: 'app-user/list',
      GetArchiveUserList: 'app-user/archive/list',
      GetAnonymousUserList: 'app-user/anonymous/list',
      DropDownList:'app-user/dropdown-list',
      GetUserById: 'app-user/detail/{appUserId}',
      SaveUser: 'app-user/save',
      ActiveInactiveUser: 'app-user/active-inactive/{appUserId}',
      DeleteUser: 'app-user/archive/{appUserId}',
      ArchiveDeleteUser: 'app-user/delete/{appUserId}',
      ReActivateDeleteUser: 'app-user/re-active/{appUserId}',
      GetUserBinders : 'app-user/binders',
      GetAllCardsByUser: 'app-user/user-binder-cards-by-set',
      ExportAppUsers: 'app-user/export',
      ExportAppUsersDropdown:'app-user/export-dropdown',
      ExportUsersWithDetails: 'app-user/export-with-details'
    },
    Game: {
      GetGameList: 'game/list',
      SaveGame: 'game/save',
      GetGameById: 'game/detail/{gameId}',
      DeleteGame: 'game/delete/{gameId}',
      ActiveInactiveGame: 'game/active-inactive/{gameId}',
      GetGameDropdown: 'game/dropdown',
    },
    Set: {
      GetSetList: 'set/list',
      ActiveInactiveSet: 'set/active-inactive/{setId}',
      DeleteSet: 'set/delete/{setId}',
      GetSet: 'set/en',
      SaveSet: 'set/save',
      SyncCard: 'set/sync-cards/{lang}/{setId}',
      GetSetById: 'set/detail/{setId}',
      ManuallySaveSet: 'set/manually-save',
      ExportExecelSets : 'set/export-sets',
      VerifySet: 'set/verify',
    },
    Card: {
      SyncSelectedCards: 'card/save',
      SaveManualSetBulk: 'card/save-manual-set-bulk',
      SaveManualSetCards: 'card/save-manual-set-cards',
      GetAllCards: 'card/get-by-setId',
      GetSetsFromCardList : 'card/sets/from-card',
      GetCardDetailsWithCardHistory : 'card/detail/{cardId}',
      GetCardDetail : 'card/detail',
      GetCardPriceHistory : 'card/history/{referenceCardId}',
      GetCardPriceHistoryRecords : 'card/history/{referenceCardId}/records',
      ManuallySaveCard: 'card/manually-save',
      DeleteCard: 'card/delete/{cardId}',
      GetCardById: 'card/detail-by-id/{cardId}',
      GetDataChanges: 'card/data-changes/{referenceCardId}',
      ResolveDataChanges: 'card/data-changes/resolve',
      ExportExcelCards: 'card/export-cards',
    },
    CardCorrection: {
      GetCardCorrectionList: 'card-correction/list',
      GetCardCorrectionById: 'card-correction/detail/{cardCorrectionId}',
      SaveCardCorrection: 'card-correction/save',
      DeleteCardCorrection: 'card-correction/delete/{cardCorrectionId}',
      GetCardCorrectionTypeDropdown: 'card-correction/type-dropdown',
      GetImportCardsList: 'card-correction/import/cards-list',
      GenerateImportTemplate: 'card-correction/import/generate-template',
      ImportCardCorrections: 'card-correction/import',
      DownloadImportRowDetails: 'card-correction/import/download-row-details',
    },
    Setting: {
      GetPrivacyPolicy: 'setting/privacy-policy',
      UpdatePrivacyPolicy: 'setting/privacy-policy/save',
      GetTermsAndCondition: 'setting/terms-condition',
      UpdateTermsAndCondition: 'setting/terms-condition/save',
      CustomUserList:'setting/preset/custom-user-list',
      SavePreset: 'setting/preset/save',
      GetPresetList:'setting/preset/list',
      DeletePreset:'setting/preset/delete/{presetId}', 
      GetPresetDetail:'setting/preset/detail/{presetId}',
      GetPresetUserSummary:'setting/preset/user-summary/{presetId}',
      PredefinedUserTypes:'setting/preset/predefined-user-types',
      ResolveImportedUsers:'setting/preset/resolve-imported-users',
      UpdateVersionInfo:'setting/app-version/save',
      GetVersionInfo:'setting/app-version/info',
      DeleteColor:'setting/color/delete/{colorId}',
      GetColorList:'setting/color/list',
      SaveColor:'setting/color/save',
      GetColorById:'setting/color/detail/{colorId}',
      ActiveInactiveColor:'setting/color/active-inactive/{colorId}',
      UpdateColorSortOrder:'setting/color/reorder',
    },
    Binder: {
      GetColors: 'binder/color',
      GetPockets: 'binder/pocket',
      GetSets: 'binder/set',
      GetById :'binder/detail/{binderId}',
      Save :'binder/save',
      GetBinderList : 'binder/list',
      ToggleNfc : 'binder/toggle-nfc/{binderId}',
      ActiveInactiveBinder: 'binder/active-inactive/{binderId}',
      UpdateBinderSortOrder: 'binder/reorder',
      DeleteBinder: 'binder/delete/{binderId}',
      AddBinderQuantity: 'binder/add-binder-quantity',
      GetBinderNfcUrls: 'binder/nfc-urls/{binderId}',
      GetNfcEnabledBinders: 'binder/nfc',
      DeleteBinderUrl: 'binder/delete-binder-urls',
      ManufactureBinderUrl: 'binder/manufacture-binder-urls',
      ExportBinderUrls: 'binder/export/{binderId}',
      ExportBinderNfcBulk: 'binder/export-nfc-bulk'
    },
    Notification:{
      Save:'notification/save',
      List:'notification/list',
      DeleteNotification:'notification/delete/{notificationId}',
      GetById: 'notification/detail/{notificationId}'
    },
    Import: {
      DownloadTemplate: 'import/template',
      UpdateNfc: 'import/update-nfc',
      DownloadRowDetails: 'import/download-row-details'
    },
    AppVersionRelease: {
      GetList: 'app-version-release/list',
      GetById: 'app-version-release/detail/{id}',
      Save: 'app-version-release/save',
      Delete: 'app-version-release/delete/{id}',
      GetResponses: 'app-version-release/responses/{releaseId}'
    },
    SupportTicket: {
      GetList: 'support-ticket/list',
      UpdateStatus: 'support-ticket/update-status',
      DownloadAttachment: 'support-ticket/attachment/{attachmentId}/download',
      GetCategoryDropdown: 'support-ticket/category-dropdown'
    }
  };
}